export const MC_CUSTWATERPRODLIST = 'mc_custwaterprodlist'
export const MC_CUSTWATERPROD = 'mc_custwaterprod'
export const MC_USERNAME = 'mc_username'
export const MC_USER = 'mc_user'
